import React from 'react';
import { router } from '@inertiajs/react';
import { getCsrfToken } from '../../lib/csrf.js';

export const labelClass = "block text-sm font-semibold text-gray-800";
export const inputClass = "mt-1.5 block w-full rounded-lg border-0 bg-white px-3.5 py-2.5 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition duration-150 hover:ring-gray-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600";
export const selectClass = `${inputClass} appearance-none bg-[length:1rem_1rem] bg-[right_0.75rem_center] bg-no-repeat pr-10 bg-[url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20fill%3D%27none%27%20viewBox%3D%270%200%2024%2024%27%20stroke-width%3D%271.5%27%20stroke%3D%27%236b7280%27%3E%3Cpath%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%20d%3D%27M19.5%208.25l-7.5%207.5-7.5-7.5%27%2F%3E%3C%2Fsvg%3E")]`;
export const primaryBtnClass = "rounded-lg bg-indigo-600 px-5 py-2.5 text-sm/6 font-semibold text-white shadow-sm ring-1 ring-inset ring-indigo-600/20 transition duration-150 hover:bg-indigo-700 hover:shadow-md cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none";
export const secondaryBtnClass = "rounded-lg bg-white px-5 py-2.5 text-sm/6 font-semibold text-gray-700 shadow-sm ring-1 ring-inset ring-gray-200 transition duration-150 hover:bg-gray-50 hover:ring-gray-300 cursor-pointer";

export const STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

export const ITEM_DEFS = [
  { key: 'Caregiver|continuing_education',  role: 'Caregiver',     training_type: 'continuing_education',  group: 'caregiver', label: 'Annual Training',       hours: '20-hour Annual Training' },
  { key: 'Caregiver|initial_training',      role: 'Caregiver',     training_type: 'initial_training',      group: 'caregiver', label: 'Initial Training',      hours: '40-hour Initial Training' },
  { key: 'Administrator|recertification',   role: 'Administrator', training_type: 'recertification',       group: 'admin',     label: 'Recertification',       hours: '40-hour Recertification' },
  { key: 'Administrator|recertification_20hr', role: 'Administrator', training_type: 'recertification_20hr', group: 'admin',   label: 'Recertification (20h)', hours: '20-hour Recertification (RCFE / ARF)' },
  { key: 'Administrator|recertification_20hr_live', role: 'Administrator', training_type: 'recertification_20hr_live', group: 'admin', label: 'Recertification (20h Live)', hours: '20-hour Live Recertification (RCFE / ARF)' },
  { key: 'Administrator|initial_certification', role: 'Administrator', training_type: 'initial_certification', group: 'admin', label: 'Initial Certification', hours: '80-hour Initial Certification', hidden: true },
];

export const VOLUME_TIERS = [
  { range: '5-9 seats',   pct: '5% OFF',   label: '5-9' },
  { range: '10-19 seats', pct: '10% OFF',  label: '10-19' },
  { range: '20+ seats',   pct: '10% OFF',  label: '20+' },
];

export const VOLUME_DISCOUNT_TIERS = [
  { min: 20, pct: 10 },
  { min: 10, pct: 10 },
  { min: 5,  pct: 5  },
];

export function CalendarIcon({ className = "h-5 w-5 text-indigo-600" }) {
  return (<svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25M3 18.75V11.25A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" /></svg>);
}
export function BookmarkIcon({ className = "h-5 w-5 text-indigo-600" }) {
  return (<svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" /></svg>);
}
export function PersonIcon() {
  return (<svg className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>);
}
export function ShieldIcon({ className = "h-5 w-5 text-indigo-500" }) {
  return (<svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 5.25-4.5 9-9 9s-9-3.75-9-9 4.5-9 9-9 9 3.75 9 9Z" /></svg>);
}

export const iconFor = {
  'Caregiver|continuing_education':       <CalendarIcon />,
  'Caregiver|initial_training':           <BookmarkIcon />,
  'Administrator|recertification':        <PersonIcon />,
  'Administrator|recertification_20hr':   <PersonIcon />,
  'Administrator|recertification_20hr_live': <CalendarIcon />,
  'Administrator|initial_certification':  <BookmarkIcon />,
};

export function clearDraft() {
  const csrf = getCsrfToken();
  return fetch('/api/buy_draft', { method: 'DELETE', headers: { 'X-CSRF-Token': csrf }, credentials: 'same-origin' }).catch(() => {});
}

export async function checkEmailAvailable(email) {
  if (!email || !/.+@.+\..+/.test(email)) return { available: false, invalid: true };
  try {
    const res = await fetch(`/api/signup/check_email?email=${encodeURIComponent(email)}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) return { available: true }; // fail-open; server-side guard will catch
    return await res.json();
  } catch {
    return { available: true };
  }
}

export function saveDraftPatch(patch) {
  const csrf = getCsrfToken();
  return fetch('/api/buy_draft/merge', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    credentials: 'same-origin',
    body: JSON.stringify({ patch }),
  });
}

export function prepareCheckout(flow) {
  const csrf = getCsrfToken();
  return fetch(`/signup/${flow}/prepare_checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrf },
    credentials: 'same-origin',
  })
    .then((response) => response.json())
    .then((body) => {
      // The draft has already been paid for. Send the buyer to that purchase's
      // completion step instead of leaving them on a checkout form that would
      // charge them a second time.
      if (body?.settled && body.redirect_to) router.visit(body.redirect_to);
    })
    .catch(() => {});
}
